import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { EmptyComponent, SkeletonComponent } from 'nebula-ui-kit';
import {
  applyVaultModuleInitialLoadErrorSignals,
  PageHeaderComponent,
  VaultModuleShellComponent,
} from '@nebula-shared/ui';
import { finalize, timeout } from 'rxjs';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
  standalone: true,
  imports: [CommonModule, PageHeaderComponent, SkeletonComponent, EmptyComponent, VaultModuleShellComponent],
})
export class AdminDashboardComponent implements OnInit {
  private static readonly MODULE_LABEL = 'Admin Dashboard';

  private readonly http = inject(HttpClient);

  readonly accessDenied = signal(false);
  readonly loadError = signal<string | null>(null);
  readonly loadErrorTitle = signal('');
  readonly loading = signal(true);
  readonly ok = signal(false);

  ngOnInit(): void {
    this.http
      .get('/api/admin/tenants')
      .pipe(
        timeout(15000),
        finalize(() => this.loading.set(false)),
      )
      .subscribe({
        next: () => this.ok.set(true),
        error: (err: unknown) =>
          applyVaultModuleInitialLoadErrorSignals(
            err,
            {
              moduleLabel: AdminDashboardComponent.MODULE_LABEL,
              fallback: 'No se pudo verificar el acceso de administración.',
            },
            {
              accessDenied: this.accessDenied,
              loadError: this.loadError,
              loadErrorTitle: this.loadErrorTitle,
            },
          ),
      });
  }
}
